import { platformClient } from './platform.client';
import { AuditLog, CreateSchoolRequest, School } from '../types';
import { StatusResponse } from '../../../types/api';

export interface InviteDevTeamRequest {
  email: string;
  invitee_name?: string;
  access_level?: string;
  notes?: string;
}

export interface DevProfile {
  id?: string;
  _id?: string;
  name?: string;
  email?: string;
  access_level?: string;
  role?: string;
  status?: string;
  created_at?: string;
  joined_at?: string;
}

interface DevProfilesResponse {
  items?: DevProfile[];
  profiles?: DevProfile[];
}

export interface AuditLogsParams {
  event_type?: string;
  limit?: number;
  skip?: number;
}

export const createSchool = async (data: CreateSchoolRequest): Promise<School> => {
  const response = await platformClient.post<School>('/dev/schools', data);
  return response.data;
};

export const inviteSchoolAdmin = async (
  schoolId: string,
  payload: { email: string; invitee_name?: string; notes?: string }
): Promise<any> => {
  const response = await platformClient.post<any>(`/dev/schools/${schoolId}/invite-admin`, payload);
  return response.data;
};

export const inviteDevTeam = async (data: InviteDevTeamRequest): Promise<StatusResponse> => {
  const response = await platformClient.post<StatusResponse>('/dev/invite', data);
  return response.data;
};

export const getAuditLogs = async (params?: AuditLogsParams): Promise<AuditLog[]> => {
  const response = await platformClient.get<AuditLog[]>('/dev/audit-logs', { params });
  return response.data;
};

export const listSchools = async (): Promise<School[]> => {
  const response = await platformClient.get<School[]>('/dev/schools');
  return response.data;
};

export const getSchools = listSchools;

export const getCreatedInvites = async (): Promise<any[]> => {
  const response = await platformClient.get<any>('/dev/invites/created');
  const body = response.data;
  if (body && typeof body === 'object' && Array.isArray(body.items)) return body.items;
  return Array.isArray(body) ? body : [];
};

export const getSchoolInvites = async (schoolId: string, purpose?: string): Promise<any[]> => {
  const response = await platformClient.get<any>(`/schools/${schoolId}/invites/created`, {
    params: purpose ? { purpose } : {},
  });
  const body = response.data;
  if (body && typeof body === 'object' && Array.isArray(body.items)) return body.items;
  return Array.isArray(body) ? body : [];
};

export const getDevProfiles = async (params?: { limit?: number; skip?: number }): Promise<DevProfile[]> => {
  const response = await platformClient.get<DevProfilesResponse>('/dev/profiles', { params });
  const body = response.data;
  if (!body) return [];
  if (Array.isArray(body)) return body;
  if (Array.isArray(body.items)) return body.items;
  if (Array.isArray(body.profiles)) return body.profiles;
  return [];
};
